import { useContainerBlockContext } from '@lighthouse/block'
import type { TableColumns } from '@lighthouse/core'
import { getWithScopeId, useAtomAction } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import { useCallback, useMemo } from 'react'

import { tablePropsCacheAtomFamily } from '@/atoms/storage/state'

interface useTablePropsPayload {
    appId: string
    envId: string
    blockId: string
}

export const useTableProps = (payload: useTablePropsPayload) => {
    const { appId, envId, blockId } = payload
    const { scope } = useContainerBlockContext()
    const withScopeId = getWithScopeId(blockId, scope)
    const { run: setTablePropsCache } = useAtomAction(tablePropsCacheAtomFamily({ appId, envId, id: withScopeId }))
    const tablePropsCache = useAtomValue(tablePropsCacheAtomFamily({ appId, envId, id: withScopeId }))

    const handleDisplayChange = useCallback(
        (data?: TableColumns) => {
            if (!data) {
                return
            }
            setTablePropsCache(data)
        },
        [setTablePropsCache]
    )

    return useMemo(() => ({ tablePropsCache, handleDisplayChange }), [handleDisplayChange, tablePropsCache])
}
